export default __webpack_public_path__ + "static/media/nachhaltigkeit.c781485c.webp";